
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.281 16.135H4.72a1.098 1.098 0 01-1.053-.865L2.038 8.417A1.13 1.13 0 013.09 6.998h13.818a1.13 1.13 0 011.053 1.42l-1.628 6.852a1.097 1.097 0 01-1.053.865zM4.29 6.997L7.714 3m7.996 3.997L12.285 3","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","stroke":"currentColor","fill":"none"}})])
          )
        }
      }
    